import eventHandlers from './callEvents'

export default {
  eventHandlers,
  mediaConstraints: {
    audio: true,
    video: false,
  }
}
